<!-- Dummy element for autofocus -->
<a href=""></a>
<div class="drawer-header">
  @if (step === 1) {
    <div class="flex gap-8">
      <nz-avatar [nzSize]="42" [nzText]="userInitials"></nz-avatar>
      <div class="flex flex-column">
        <p class="text-semibold text-dark">{{user?.displayName || 'Usuario'}}</p>
        <p class="fs-xs">{{user?.email || 'usuario@cecbi.com'}}</p>
      </div>
    </div>
  } @else {
    <button nz-button nzType="text" (click)="changeStep(1)">
      <app-icon [name]="'arrow-left'" [size]="'base'"></app-icon>
      <span class="fs-xs">Volver</span>
    </button>
  }

  <app-icon (click)="close()" class="cursor-pointer" [name]="'x'" [size]="'base'"></app-icon>
</div>

<div class="drawer-content">

  @if (step === 1) {
    <nz-card>
      <div class="flex flex-column gap-21">
        <div class="flex flex-center-start gap-8">
          <app-icon [name]="'building-2'" [size]="'base'" color="#12DB88"></app-icon>
          <p class="fs-xs text-dark">Entidad Activa</p>
        </div>

        <div class="flex flex-center-between gap-8">
          <p class="text-dark">{{company?.name || 'Empresa'}}</p>

          <div class="badge green">
            <span>Activo</span>
          </div>
        </div>

      </div>
    </nz-card>

    <nz-card>
      <div class="flex flex-column gap-21">
        <div class="flex flex-center-start gap-8">
          <app-icon [name]="'clock'" [size]="'base'" color="#12DB88"></app-icon>
          <p class="fs-xs text-dark">Información del Usuario</p>
        </div>

        <div class="flex flex-column gap-8">
          <div class="flex-center-start gap-8">
            <app-icon name="user" [size]="'base'"></app-icon>
            <span class="fs-xxs">Nombre completo</span>
          </div>
          <p>{{user?.displayName || 'Usuario'}}</p>
        </div>

        <div class="flex flex-column gap-8">
          <div class="flex-center-start gap-8">
            <app-icon name="mail" [size]="'base'"></app-icon>
            <span class="fs-xxs">Correo electrónico</span>
          </div>
          <p>{{user?.email || 'user@email.com'}}</p>
        </div>

      </div>
    </nz-card>

    <div class="flex flex-column gap-8 btns-container">
      <button nz-button nzType="default" class="w-100" (click)="changeStep(2)">
        <app-icon name="arrow-right-left" size="base"></app-icon>
        <p>Cambiar Entidad</p>
      </button>

      <button nz-button nzType="default" class="w-100" (click)="changePass()">
        <app-icon name="lock-open" size="base"></app-icon>
        <p>Cambiar Contraseña </p>
      </button>

      <button nz-button nzType="default" class="w-100" (click)="openConfirmLogout()" nzDanger>
        <app-icon color="#EF4444" name="log-out" size="base"></app-icon>
        <p style="color: #EF4444">Cerrar sesión</p>
      </button>
    </div>
  } @else {

    <div>
      <div class="flex flex-center-start gap-8">
        <app-icon [name]="'building-2'" [size]="'base'" color="#12DB88"></app-icon>
        <p class="fs-md text-dark">Cambiar Entidad</p>
      </div>

      <p class="fs-xs text-light">Selecciona la entidad con la que deseas trabajar. Tu
        sesión se mantendrá activa.</p>
    </div>

    <div style="border-top: 1px solid #0000001A; padding-top: 24px">
      <nz-card>
        <div class="flex flex-column gap-21">
          <div class="flex flex-center-start gap-8">
            <div class="mini-card" style="background-color: #12DB881A">
              <app-icon [name]="'building-2'" [size]="'base'" color="#12DB88"></app-icon>
            </div>
            <p class="fs-xs text-dark">Entidad Activa</p>
          </div>

          <div class="flex flex-center-between gap-8">
            <p class="text-dark">{{company?.name || 'Empresa'}}</p>

            <div class="badge green">
              <span>Activo</span>
            </div>
          </div>
        </div>
      </nz-card>
    </div>
    <div class="flex flex-column gap-16">
      <p class="text-dark text-semibold fs-sm">Entidades Disponibles</p>
        <nz-radio-group class="flex flex-column gap-8" [(ngModel)]="selectedCompanyId">
          @for (userCompany of user?.companies; track userCompany.id) {
            <label nz-radio [nzValue]="userCompany.id">
              <span class="text-dark">{{userCompany.name}}</span>
            </label>
          }
        </nz-radio-group>
    </div>
    <div class="flex flex-center-between gap-8" style="border-top: 1px solid #0000001A; padding-top: 24px">
      <button (click)="step = 1" class="flex flex-center-center" nz-button nzType="default" style="width: 50%">Cancelar</button>
      <button (click)="selectCompany()" class="flex flex-center-center" nz-button nzType="primary" style="width: 50%">Confirmar</button>
    </div>

  }

</div>
